import CGNavBar from "src/pages/ComplianceGuide/NavBar";
import Paywall from "src/pages/ComplianceGuide/Paywall";
import Loading from "src/components/Loading";
import BackToTop from "src/components/BackToTop";
import { useSignupAccess } from "src/hooks/useSignupAccess";
import { useLayoutContext } from "src/contexts/LayoutContext";

type ComplianceGuideLayoutProps = {
  children: React.ReactNode;
};

const ComplianceGuideLayout: React.FC<ComplianceGuideLayoutProps> = ({
  children,
}) => {
  const access = useSignupAccess("complianceguide");
  const isLoading = access.isPending;
  const hasComplianceGuide = access.data?.hasAccess ?? false;

  const { heading, tagline } = useLayoutContext();

  return (
    <>
      <div className="d-flex">
        <CGNavBar />
        <BackToTop />
        <div className="container-fluid maint-content show-scroll-back-to-top">
          {isLoading ? (
            <Loading />
          ) : (
            <>
              {/* Show the Paywall INSTEAD of the page when the user lacks Compliance Guide
                  access. The children used to render underneath the (translucent, blurred)
                  paywall overlay, so pieces of the page — most visibly the AI Assistant's
                  chat panel and anything it portals to <body> — bled through on top of it.
                  Not mounting them also stops their API calls from firing for users who
                  aren't entitled to the feature. */}
              {!hasComplianceGuide && access.data ? (
                <Paywall isAdmin={access.data.canPurchase} />
              ) : (
                <main>
                  <div id="compGuideMenuBtn">
                    <button
                      aria-controls="mobileCompGuideMenuNav"
                      className="btn btn-primary submenu-cta"
                      data-bs-target="#mobileCompGuideMenuNav"
                      data-bs-toggle="offcanvas"
                      type="button"
                    >
                      <i className="bi bi-card-list subnav-menu"></i>{" "}
                      <span className="submenu-header">
                        Compliance Guide Menu
                      </span>
                    </button>
                  </div>
                  <div className="compliance-guid-main-container">
                    <div>
                      <div className="col pagetitle">{heading}</div>

                      <div className="row w-100">
                        <div className="col">
                          <p>{tagline}</p>
                        </div>
                      </div>

                      {children}
                    </div>
                  </div>
                </main>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ComplianceGuideLayout;
